import React from 'react';
import Stack from '@mui/material/Stack';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';

interface CardPaginationProps {
    page: number;
    pageSize: number;
    arrayLength: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPageSize: React.Dispatch<React.SetStateAction<number>>
}

const iconsCss = { width: 20, height: 20 }
const btnCss = { border: '1px solid grey', paddign: 6 }

export const CardPagination: React.FC<CardPaginationProps> = ({ page, pageSize, arrayLength, setPage }) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    const handlePrevious = () => {
        if (page > 1) {
            setPage(page - 1);
        } else {
            setPage(1);
        }
    }

    const handleNext = () => {
        if (!(arrayLength < pageSize)) {
            setPage(page + 1);
        }
    }

    const buttonStyles = (disabled: boolean) => ({
        ...btnCss,
        cursor: disabled ? 'not-allowed' : 'pointer',
        color: darkMode && disabled ? 'white' : 'inherit',
        backgroundColor: disabled ? (darkMode ? '#333' : '#e0e0e0') : 'inherit', // Example disabled background color
    });

    return (
        <div className='ms-auto d-flex flex-row align-items-center justify-content-center me-2 gap-3'>
            <span className={darkMode ? 'text-white text-nowrap' : 'text-muted text-nowrap'} style={{ fontSize: 13 }}>
                {language['Page']}: {page}
            </span>
            <Stack direction="row" spacing={0} style={{ height: 34 }}>
                <button
                    disabled={page === 1}
                    onClick={handlePrevious}
                    className={`btn d-flex align-items-center justify-content-center ${darkMode && 'text-white'}`}
                    style={{
                        ...buttonStyles(page === 1),
                        borderEndEndRadius: 0,
                        borderStartEndRadius: 0,
                        borderRight: 'none',
                    }}>
                    <ChevronLeftIcon sx={iconsCss} />
                </button>
                <button
                    disabled={(arrayLength < pageSize)}
                    onClick={handleNext}
                    className='btn d-flex align-items-center justify-content-center'
                    style={{
                        ...buttonStyles(arrayLength < pageSize),
                        borderEndStartRadius: 0,
                        borderStartStartRadius: 0,
                    }}>
                    <ChevronRightIcon sx={iconsCss} />
                </button>
            </Stack>
        </div>
    );
}
export default CardPagination